import Route from "vue-routisan";
import isAuthenticated from "./middlewares/isAuthenticated";

Route.group({}, () => {
  Route.group({prefix: "billing", beforeEnter: [isAuthenticated]}, () => {

    Route.redirect("/", to => {
      return {name: "billing"};
    });

    Route.view("/home", () =>
      import(/* webpackChunkName: "billing" */ "@/resources/views/billing/BillingHome.vue")
    )
    .name("billing.home")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "billing" */ "src/resources/views/billing/layout.vue/Layout.vue")
      }
    });

    Route.view("/list", () =>
      import(/* webpackChunkName: "billing" */ "@/resources/views/billing/BillingList.vue")
    )
    .name("billing")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "billing" */ "src/resources/views/billing/layout.vue/Layout.vue")
      }
    });

    Route.view("/closing_day", () =>
      import(/* webpackChunkName: "billing" */ "@/resources/views/billing/BillingClosingDay.vue")
    )
    .name("billing.closing_day")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "billing" */ "src/resources/views/billing/layout.vue/Layout.vue")
      }
    });

  });
});

export default Route.all();
